import {useCallback, useEffect, useState} from 'react'
import {addServerPrefix, serverPhoneFormat} from 'services/utils/apiUtils'
import {useSignupMutation} from 'store/Store'

const useSignup = () => {
    const [signupResponse, setSignupResponse] = useState()
    const [signupError, setSignupError] = useState()

    const clearSignupError = () => setSignupError(null)

    const [doSignup, {data, error}] = useSignupMutation()

    useEffect(() => {
        if (data?.error) {
            setSignupError(data?.error?.data)
            return
        }
        if (!data?.success) {
            setSignupError(data?.data?.msg)
            return
        }

        setSignupResponse(data)
    }, [data])

    useEffect(() => {
        setSignupError(error)
    }, [error])

    const signup = useCallback(
        async (signupData) => {
            const {username, firstName, lastName, id, ...rest} = signupData

            try {
                await doSignup({
                    firstname: firstName.trim(),
                    lastname: lastName.trim(),
                    phone: serverPhoneFormat(username),
                    userReferral: `planneragent`,
                    id: addServerPrefix(id, 'planneragent_'),
                    ...rest,
                })
            } catch (error) {
                setSignupError(error)
            }
        },
        [doSignup]
    )

    return {doSignup: signup, signupError, signupResponse, clearSignupError}
}

export default useSignup
